import React from 'react'

import { LANGUAGE } from '@bikemap/js/settings'
import { gettext } from '@bikemap/js/services'

import BasePromotionModal from '../BasePromotionModal.jsx'
import { getImageVariants } from '../helpers.js'

const learnMoreHref = LANGUAGE === 'de'
    ? 'https://help.bikemap.net/hc/de/articles/12773741053852-Bikemap-Gewinnspiel'
    : 'https://help.bikemap.net/hc/en-us/articles/12773741053852-Bikemap-Giveaway'

const Modal = () => {
    const modalProps = {
        label: gettext('Giveaway'),
        title: gettext('Exclusive In-App Giveaway for Premium Users'),
        description: gettext('As a Premium user you can join our <b>In-App Giveaway</b> through Bikemap for iOS and Android. For this exclusive giveaway, we\'re offering <b>one TENWAYS CGO009 e-bike</b>, <b>8x2 tickets to a BVB football match</b> as well as <b>5 upgrades to Bikemap Lifetime Premium</b>.'),
        cta: gettext('Open Bikemap for iOS or Android'),
        imageAlt: gettext('Promotion'),
        img: getImageVariants('tenways-giveaway'),
        ctaLink: 'https://bikemap.page.link/ebikegiveaway',
        finePrint: gettext('The giveaway closes on March 31, 2024. Winners will be drawn the following week.'),
    }

    return (
        <BasePromotionModal
            {...modalProps}
            learnMoreLink={<a href={learnMoreHref}>{LANGUAGE === 'de' ? <>Mehr&nbsp;erfahren</> : <>Learn&nbsp;more</>}</a>}
        />
    )
}

export default Modal
